import ReactGA from 'react-ga';

const TRACKING_ID: string = process.env.REACT_APP_GA_KEY || '';

const init = () => {
	const isDev =
		!process.env.NODE_ENV || process.env.NODE_ENV === 'development';
	ReactGA.initialize(TRACKING_ID, { debug: isDev });
	ReactGA.ga('set', 'anonymizeIp', true);
};

const sendEvent = (payload: any) => ReactGA.event(payload);
const sendPageview = (path: any) => {
	ReactGA.set({ page: path });
	ReactGA.pageview(path);
};

export default {
	init,
	sendEvent,
	sendPageview,
};
